import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("khn_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  const pabrik = localStorage.getItem("khn_pabrik");
  if (pabrik) cfg.headers["X-Pabrik-Id"] = pabrik;
  return cfg;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  const clean = (m) => String(m).replace(/^Value error,\s*/i, "");
  if (!d) return err?.message || "Terjadi kesalahan";
  if (typeof d === "string") return clean(d);
  if (Array.isArray(d)) return d.map((e) => clean(e?.msg || JSON.stringify(e))).join(", ");
  return clean(d);
}
